import { httpFetch } from "../../Utils/httpUtils";
import { subscriptionActionTypes as actionTypes } from "../../ActionTypes/Voss/subscriptionActionTypes";
import commonActions from "../commonActions";
import { commonActionTypes } from "../../ActionTypes/commonActionTypes";
import formActions from "../formActions";
import forms from "../../Constants/forms";
import { TerminationConfigs, TerminationTypes } from "../../Constants/VOSS/Termination/TerminationConfigs";
import moment from 'moment';
import orderTypeMap from "../../Constants/orderTypeMap";
import subscriptionUtils from "../../Utils/subscriptionUtils";

const subscriptionActions = {

    getSubscription: (id, actionType = actionTypes.STORE_SUBSCRIPTION, callback) => {
        return (dispatch) => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "subscription", value: true });
            return httpFetch(`/api/subscriptions/${id}`, dispatch)
                .then(json => {
                    if (actionType)
                        dispatch({ type: actionType, data: json });
                    if (callback)
                        callback(json);
                }).finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "subscription", value: false });
                });
        }
    },

    getSubscriptionProductGroups: (id, status) => {
        return (dispatch) => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "productGroups", value: true });
            return httpFetch(`/api/subscriptions/${id}/productgroups/${status}`, dispatch)
                .then(json => {
                    dispatch({ type: actionTypes.STORE_SUBSCRIPTION_PRODUCT_GROUPS, data: json });
                }).finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "productGroups", value: false });
                });
        }
    },

    getSubscriptionLicenses: (customerId, subscriptionId, status) => {
        return (dispatch) => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "licenses", value: true });
            return httpFetch(`/api/customer/${customerId}/subscriptions/${subscriptionId}/licenses/${status}`, dispatch)
                .then(json => {
                    dispatch({ type: actionTypes.STORE_SUBSCRIPTION_LICENSES, data: json });
                }).finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "licenses", value: false });
                });
        }
    },

    getIntermediaries(status) {
        return (dispatch) => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "intermediaries", value: true });
            return httpFetch(`/api/intermediaries/intermediaries?status=${status}`, dispatch)
                .then(json => {
                    dispatch({ type: commonActionTypes.STORE_INTERMEDIARIES, data: json });
                }).finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "intermediaries", value: false });
                });
        }
    },

    initializeModifySubscriptionForm: (subscription) => {
        return (dispatch) => {
            dispatch(commonActions.startFormEditing(forms.modifySubscription, {
                planId: subscription.plan.id,
                tierId: subscription.tier.id,
                id: subscription.id,
                salesPersonEmail: null,
                intermediaryInvoicingId: subscription.intermediary.invoicingId,
                endDate: subscription.bindingPeriod.endDate && !subscriptionUtils.hasEvergreenBillingPeriod(subscription)
                    ? moment(subscription.bindingPeriod.endDate).format('YYYY-MM-DD')
                    : null,
                orderType: 'ordinary'
            }));
        }
    },

    initializeTerminateSubscriptionItemForm: (form) => {
        return (dispatch) => {
            dispatch(formActions.startFormEditing(form, {
                ...TerminationConfigs[TerminationTypes.CurrentPeriodEnd],
                orderType: 'ordinary'
            }));
        }
    },

    terminateSubscriptionLicense: (id, licenseId, form, callback) => {
        return (dispatch) => {

            const httpRequest = {
                method: 'POST',
                body: JSON.stringify({
                    timing: form.data.timing,
                    creditOptions: {
                        behaviour: form.data.behaviour,
                        creditKind: form.data.creditKind,
                    },
                    periodAnchor: form.data.periodAnchor,
                    invoiceLineTexts: form.data.invoiceLineTexts ? [form.data.invoiceLineTexts] : [],
                    orderType: orderTypeMap[form.data.orderType] ?? 0,
                    salesPersonEmail: form.data.salesPersonEmail
                })
            };

            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "subscription", value: true });
            return httpFetch(`/api/subscriptions/${id}/licenses/${licenseId}/termination`, dispatch, httpRequest)
                .then(json => {
                    callback();
                    dispatch(commonActions.showSuccess('License terminated successfully!'));
                }).finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "subscription", value: false });
                });
        }
    },

    deleteLicenseTermination: (id, licenseId, callback) => {
        return (dispatch) => {
            return httpFetch(`/api/subscriptions/${id}/licenses/${licenseId}/termination`, dispatch, { method: 'DELETE' })
                .then(json => {
                    callback();
                    dispatch(commonActions.showSuccess('License termination cancelled successfully!'));
                })
        }
    },

    terminateSubscriptionProductGroup: (id, productGroupId, form, callback) => {
        return (dispatch) => {

            const httpRequest = {
                method: 'POST',
                body: JSON.stringify({
                    timing: form.data.timing,
                    creditOptions: {
                        behaviour: form.data.behaviour,
                        creditKind: form.data.creditKind,
                    },
                    periodAnchor: form.data.periodAnchor,
                    invoiceLineTexts: form.data.invoiceLineTexts ? [form.data.invoiceLineTexts] : [],
                    orderType: orderTypeMap[form.data.orderType] ?? 0,
                    salesPersonEmail: form.data.salesPersonEmail
                })
            };

            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "subscription", value: true });
            return httpFetch(`/api/subscriptions/${id}/productgroups/${productGroupId}/termination`, dispatch, httpRequest)
                .then(json => {
                    callback();
                    dispatch(commonActions.showSuccess('Product group terminated successfully!'));
                }).finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "subscription", value: false });
                });
        }
    },

    deleteProductGroupTermination: (id, productGroupId, callback) => {
        return (dispatch) => {
            return httpFetch(`/api/subscriptions/${id}/productgroups/${productGroupId}/termination`, dispatch, { method: 'DELETE' })
                .then(json => {
                    callback();
                    dispatch(commonActions.showSuccess('Product group termination cancelled successfully!'));
                })
        }
    },

    deleteSubscriptionTermination: (id, callback) => {
        return (dispatch) => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "deleteSubscriptionTermination", value: true });
            return httpFetch(`/api/subscriptions/${id}/termination`, dispatch, { method: 'DELETE' })
                .then(json => {
                    callback();
                    dispatch(commonActions.showSuccess('Subscription termination cancelled successfully!'));
                }).finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "deleteSubscriptionTermination", value: false });
                });
        }
    },

    deleteScheduledChange: (id, scheduledChangeId, callback) => {
        return (dispatch) => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "subscription", value: true });
            return httpFetch(`/api/subscriptions/${id}/scheduledchanges/${scheduledChangeId}`, dispatch, { method: 'DELETE' })
                .then(json => {
                    callback();
                    dispatch(commonActions.showSuccess('Scheduled change has been deleted successfully!'));
                }).finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "subscription", value: false });
                });
        }
    },

    modifySubscription: (form, changeEmail, callback) => {
        return (dispatch) => {
            const httpRequest = {
                method: 'PUT',
                body: JSON.stringify({
                    ...form.data,
                    orderType: orderTypeMap[form.data.orderType] ?? 0,
                    notifyUser: !!changeEmail,
                    changeEmail
                })
            };

            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "modifySubscription", value: true });
            return httpFetch(`/api/subscriptions/${form.data.id}`, dispatch, httpRequest)
                .then(json => {
                    callback();
                    dispatch(commonActions.showSuccess('Subscription modified successfully!'));
                }).finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "modifySubscription", value: false });
                });
        }
    },

    getChangeEmailTemplate: (subscriptionId, newTierId, newPlanId) => {
        return (dispatch) => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "changeEmailTemplate", value: true });
            return httpFetch(`/api/termination/GetVossChangeEmailTemplate/${subscriptionId}?newTierId=${newTierId}&newPlanId=${newPlanId}`, dispatch)
                .catch(() => null)
                .finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "changeEmailTemplate", value: false });
                });
        }
    },

    getSubscriptionWarrantyEligibility(subscriptionId, callback) {
        return (dispatch) => {
            return httpFetch(`/api/subscriptions/${subscriptionId}/warranty`, dispatch)
                .then(json => {
                    callback(json);
                })
        }
    },

    reactivateSubscription: (subscriptionId, callback) => {
        return (dispatch) => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "reactivateSubscription", value: true });
            return httpFetch(`/api/subscriptions/${subscriptionId}/termination`, dispatch, { method: 'DELETE' })
                .then(json => {
                    dispatch(commonActions.showSuccess('Subscription reactivated successfully!'));
                    if (callback) {
                        callback(json);
                    }
                }).finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "reactivateSubscription", value: false });
                });
        }
    },

    clear: (key) => {
        return (dispatch) => {
            dispatch({ type: actionTypes.CLEAR, key });
        }
    },

    getAvailableMigration: (customerId, packageId) => {
        return (dispatch) => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "availableMigration", value: true });
            return httpFetch(`/api/subscriptions/available-migration/${customerId}/${packageId}`, dispatch)
                .then(json => {
                    dispatch({ type: actionTypes.STORE_AVAILABLE_MIGRATION, data: json?.status ? null : json });
                }).finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "availableMigration", value: false });
                });
        }
    },
}

export default subscriptionActions;